import { Component, OnInit, Input, HostBinding } from '@angular/core';

interface ITaskStepMetaData {
    appName: string;
    selection: any[];
}

@Component({
    selector: 'zoom-steps',
    templateUrl: './steps.component.html',
    styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {
    @Input() currentStep;
    @Input() steps;
    @Input() isBottomPosition: boolean;
    @HostBinding('class') get class() {
        return this.isBottomPosition ? 'bottom' : null;
    }
    @Input() set metaData(metaData: ITaskStepMetaData) {
        this.processMetaData(metaData);
    }
    public responsiveStepsClass: string = 'mini';
    public metaDataDisplay: string = '';
    public stepToDisplayMetaData: string = '';

    constructor() {}

    ngOnInit() {
        this.responsiveStepsClass = this.getStringLength(this.steps.length);
    }

    /**
     * The client handles title and meta processing in lieu of offloading this to the back end
     * TODO: Add a sturdier identifier (id) to JSON so we don't rely on comparing to the title
     */
    private processMetaData(metaData) {
        if (metaData.appName === 'meeting') {
            const numberOfSelections = metaData.selection && metaData.selection.length;
            this.stepToDisplayMetaData = 'Invitees';
            this.metaDataDisplay = numberOfSelections ? `(${numberOfSelections})` : '';
        }
    }

    private getStringLength(stepLength: number) {
        switch (stepLength) {
            case 1:
                return 'one';
            case 2:
                return 'two';
            case 3:
                return 'three';
            case 4:
                return 'four';
            default:
                return 'mini';
        }
    }
}
